import React, { createContext, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import * as actions from './actions';
import * as selectors from './selectors';

export const AuthContext = createContext({
    hasPermission: () => {}
});

const AuthProviderWrapper = (props) => {
    const {
        userPermissions,
        fetchingPermissions,
        fetchingPermissionsError,
        getUserPermissionsRequest
    } = props;

    useEffect(
        () => {
            if (
                !userPermissions
                && !fetchingPermissions
                && !fetchingPermissionsError
            ) {
                getUserPermissionsRequest();
            }
        },
        [
            userPermissions,
            fetchingPermissions,
            fetchingPermissionsError,
            getUserPermissionsRequest
        ]
    );

    const hasPermission = useCallback(
        permission => userPermissions && userPermissions.includes(permission),
        [userPermissions]
    );
    return (
        <AuthContext.Provider value={ hasPermission }>
            { props.children }
        </AuthContext.Provider>
    );
};

AuthProviderWrapper.propTypes = {
    userPermissions: PropTypes.arrayOf(PropTypes.string),
    fetchingPermissions: PropTypes.bool,
    fetchingPermissionsError: PropTypes.string,
    getUserPermissionsRequest: PropTypes.func.isRequired,
    children: PropTypes.node
};

AuthProviderWrapper.defaultProps = {
    userPermissions: null,
    fetchingPermissions: false,
    fetchingPermissionsError: null,
    children: null
};

const mapStateToProps = state => ({
    userPermissions: selectors.permissions(state),
    fetchingPermissions: selectors.permissionsFetching(state),
    fetchingPermissionsError: selectors.permissionsError(state)
});

const mapDispatchToProps = {
    getUserPermissionsRequest: actions.getUserPermissionsRequest
};

export const AuthProvider = connect(
    mapStateToProps,
    mapDispatchToProps
)(AuthProviderWrapper);
export const AuthConsumer = AuthContext.Consumer;
